module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ProductAgreementView.js"));
	}, "ProductAgreementView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductAgreementView!./src/pages/Shop/Member/Agreements/ProductAgreement/ProductAgreementView.js
// module id = 943
// module chunks = 438